import { createStore } from 'zustand';
import { WalletNavigationStore, WalletNavigationStoreFunction } from './WalletNavigationContext';

export const createWalletNavigationStore = (
    predefinedData?: Partial<WalletNavigationStore & WalletNavigationStoreFunction>
) => {
    return createStore<WalletNavigationStore & WalletNavigationStoreFunction>()(set => ({
        isForgetPinFlow: false,
        previousPath: 'walletAuth',
        setIsForgetPinFlow: isForgetPinFlow => set(() => ({ isForgetPinFlow })),
        setPreviousPath: previousPath => set(() => ({ previousPath })),
        ...predefinedData,
    }));
};
